module.exports = __webpack_public_path__ + "static/media/icon-search.c9c91ac5.svg";